import { queryKeys } from "../queryKeys";
import { getSipSnapshot, type Quote } from "../rest/data";
import useRequest, { type QueryOptions } from "./useRequest";

interface UseGetSipSnapshotArgs {
  symbol: string;
  options?: QueryOptions<Quote | null>;
}

export const useGetSipSnapshot = ({
  symbol,
  options,
}: UseGetSipSnapshotArgs) => {
  // v5 throws if a query fn resolves `undefined`; store `null` for "no
  // quote found" instead and remap back to `undefined` below.
  const { data, isLoading, isFetching, error, errorUpdatedAt, refetch } =
    useRequest<Quote | null>(
      queryKeys.quotes.sipSnapshot(symbol),
      async () => (await getSipSnapshot(symbol)) ?? null,
      options,
    );

  return {
    sipQuote: data ?? undefined,
    isLoading,
    isFetching,
    error,
    errorUpdatedAt,
    refetch,
  };
};
